<template>
  <svg width="131" height="40" viewBox="0 0 131 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M58.04 25.764L55.726 23.424C54.764 24.334 53.854 24.906 52.528 24.906C50.37 24.906 48.992 23.19 48.992 21.058V21.006C48.992 18.952 50.396 17.21 52.372 17.21C53.776 17.21 54.66 17.808 55.544 18.744L57.962 16.144C56.662 14.688 55.024 13.804 52.398 13.804C48.134 13.804 45.092 17.08 45.092 21.058V21.11C45.092 25.088 48.16 28.312 52.346 28.312C55.128 28.312 56.688 27.246 58.04 25.764ZM68.9155 17.938V13.804C66.5755 13.7 65.2755 14.948 64.4695 16.872V14.064H60.5175V28H64.4695V22.852C64.4695 19.524 66.0815 17.938 68.7075 17.938H68.9155ZM83.8998 21.422V21.37C83.8998 17.418 81.7678 13.804 77.1138 13.804C73.0578 13.804 70.2238 17.08 70.2238 21.058V21.11C70.2238 25.374 73.3178 28.312 77.5038 28.312C80.0258 28.312 81.8978 27.324 83.1978 25.712L80.9358 23.71C79.8438 24.724 78.8818 25.14 77.5558 25.14C75.7878 25.14 74.5398 24.204 74.1498 22.41H83.8478C83.8738 22.046 83.8998 21.812 83.8998 21.422ZM80.0518 19.94H74.0978C74.4098 18.146 75.4758 16.976 77.1138 16.976C78.7778 16.976 79.8178 18.172 80.0518 19.94ZM100.755 28V9.02H96.8032V15.884C95.8672 14.766 94.5672 13.804 92.4612 13.804C89.1592 13.804 86.1172 16.352 86.1172 21.006V21.058C86.1172 25.712 89.2112 28.26 92.4612 28.26C94.5152 28.26 95.8412 27.298 96.8032 25.998V28H100.755ZM96.8552 21.058C96.8552 23.372 95.3212 24.906 93.4752 24.906C91.6292 24.906 90.0692 23.372 90.0692 21.058V21.006C90.0692 18.666 91.6292 17.158 93.4752 17.158C95.3212 17.158 96.8552 18.692 96.8552 21.006V21.058ZM114.4 23.762V23.71C114.4 21.162 112.138 20.226 110.188 19.576C108.68 19.056 107.354 18.692 107.354 17.912V17.86C107.354 17.314 107.848 16.898 108.81 16.898C109.824 16.898 111.202 17.392 112.58 18.198L114.088 15.468C112.58 14.454 110.656 13.856 108.888 13.856C106.08 13.856 103.792 15.442 103.792 18.276V18.328C103.792 21.032 106.002 21.942 107.952 22.514C109.486 22.982 110.838 23.268 110.838 24.126V24.178C110.838 24.802 110.318 25.218 109.174 25.218C107.874 25.218 106.288 24.646 104.78 23.554L103.09 26.154C104.936 27.61 107.12 28.26 109.07 28.26C112.086 28.26 114.4 26.856 114.4 23.762ZM130.008 14.064H125.9L122.858 23.554L119.686 14.064H115.5L120.96 28.052C120.622 28.754 120.258 28.962 119.582 28.962C119.062 28.962 118.412 28.728 117.892 28.416L116.566 31.276C117.58 31.874 118.646 32.238 120.076 32.238C122.442 32.238 123.586 31.172 124.652 28.338L130.008 14.064Z"
      fill="#0F2C37"
    />
    <rect width="40" height="40" rx="8" fill="white" />
    <mask
      id="logo-mark-type-mobile-mask0_1926_16360"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="16"
      y="16"
      width="16"
      height="17"
    >
      <rect
        x="16.416"
        y="32.0002"
        width="15.5844"
        height="15.5844"
        transform="rotate(-90 16.416 32.0002)"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#logo-mark-type-mobile-mask0_1926_16360)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23.5855 32C23.5856 27.3523 27.3533 23.5846 32.0011 23.5846C32.0014 23.5846 32.0017 23.5846 32.002 23.5846L32.002 16.4156C29.9554 16.4156 27.9288 16.8187 26.0381 17.6019C24.1473 18.3851 22.4293 19.533 20.9821 20.9802C19.535 22.4273 18.387 24.1453 17.6038 26.0361C16.8206 27.9269 16.4175 29.9534 16.4175 32L23.5855 32Z"
        fill="#BCD0D7"
      />
    </g>
    <mask
      id="logo-mark-type-mobile-mask1_1926_16360"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="8"
      y="16"
      width="16"
      height="16"
    >
      <rect x="8" y="16.4155" width="15.5844" height="15.5844" fill="#D9D9D9" />
    </mask>
    <g mask="url(#logo-mark-type-mobile-mask1_1926_16360)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 23.5844L8 16.4156C10.0466 16.4156 12.0731 16.8187 13.9639 17.6019C15.8547 18.3851 17.5727 19.533 19.0198 20.9802C20.467 22.4273 21.6149 24.1453 22.3981 26.0361C23.1813 27.9269 23.5844 29.9534 23.5844 32L16.4157 32C16.4157 27.3522 12.648 23.5844 8.00017 23.5844C8.00011 23.5844 8.00006 23.5844 8 23.5844Z"
        fill="#016299"
      />
    </g>
    <mask
      id="logo-mark-type-mobile-mask2_1926_16360"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="16"
      y="7"
      width="16"
      height="17"
    >
      <rect x="16.416" y="7.99976" width="15.5844" height="15.5844" fill="#D9D9D9" />
    </mask>
    <g mask="url(#logo-mark-type-mobile-mask2_1926_16360)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.0365 22.3982C27.9273 23.1814 29.9539 23.5845 32.0004 23.5845L32.0004 16.4153C32.0002 16.4153 32 16.4153 31.9999 16.4153C27.3522 16.4153 23.5845 12.6477 23.5843 8.00006L16.416 8.00006C16.416 10.0466 16.8191 12.0732 17.6023 13.964C18.3855 15.8547 19.5334 17.5728 20.9806 19.0199C22.4277 20.4671 24.1457 21.615 26.0365 22.3982Z"
        fill="#1292DA"
      />
    </g>
  </svg>
</template>
